module.exports = __webpack_public_path__ + "img/society1.8be14a57.jpg";